var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { useQuery } from '@apollo/client/react';
import { SelectWithInputDocument } from './SelectWithInput.gql';
export function useGetPropertyValues(name, existing) {
    const _a = useQuery(SelectWithInputDocument, {
        skip: !name,
        variables: {
            name,
        },
    }), { data } = _a, rest = __rest(_a, ["data"]);
    const pairs = ((data === null || data === void 0 ? void 0 : data.documentMetadataPairsDistinctValuesForProperty) || []);
    const existingValues = Array.isArray(existing) ? existing : [existing];
    const uniquePairs = [...new Set([...pairs, ...existingValues])].reduce((acc, pair) => {
        if (typeof pair !== 'string') {
            return acc;
        }
        const trimmedValue = pair.trim();
        if (trimmedValue === '') {
            return acc;
        }
        return [...acc, trimmedValue];
    }, []);
    return Object.assign({ data: uniquePairs }, rest);
}
